import ApiService from './ApiService';
import AuthService from './AuthService';

class StatService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._downloadSellerPresent = '/stat/download-seller-presentation';

    }

    presentationCountRegister() {
        return this.postResource(this._downloadSellerPresent, {}, this.getLangHeader())
    }
}

const service = new StatService(AuthService);

export default service;
